import type { ProcessEngineTask } from '../../../../enum';
import type { IBsiCustomer } from '../bsi-customer';

export enum EBankingContractLoginType {
    MTAN = 'MTAN',
    OTAN = 'OTAN',
}

export interface IBsiEBankingContractCreationInput {
    customer: IBsiCustomer;
    accountNrs: string[]; // KT_LNR
    permissionType: string; // Finnova Werteliste
    loginType: EBankingContractLoginType; // MTAN oder OTAN
    notes?: string; // maxLength = 250
}

export interface IBsiEBankingContractCreationTask {
    taskType: ProcessEngineTask.CREATE_EBANKING_CONTRACT;
    BsiCaseInput: IBsiEBankingContractCreationInput;
}
